module.exports = __webpack_public_path__ + "static/media/csl.5ea5d436.webp";